<template>
  <h1>Docs</h1>
</template>
<style scoped>
h1 {
  margin: 0;
  margin-bottom: 0.5em;
}
</style>
